import styled from 'styled-components';
var ButtonGroup = styled.div.withConfig({
  displayName: "ButtonGroup",
  componentId: "sc-1cq18cv-0"
})(["display:inline-block;position:relative;vertical-align:middle;"]);
export default ButtonGroup;